import { Chip, type TChipSize, type TChipVariant } from "../Chip";

interface IStaticChipProps {
  disabled?: boolean;
  PrefixIcon?: IconComponent;
  selected?: boolean;
  size?: TChipSize;
  SuffixIcon?: IconComponent;
  variant?: TChipVariant;
}

/** @deprecated Use the new `Badge` component from `components/ui/badge`. */
export const StaticChip: FC<IStaticChipProps> = ({
  children,
  className,
  disabled = false,
  PrefixIcon,
  ref,
  selected = false,
  size,
  SuffixIcon,
  variant = "regular",
  ...restProps
}) => {
  return (
    <Chip
      className={className}
      disabled={disabled}
      PrefixIcon={PrefixIcon}
      readonly
      ref={ref}
      selected={selected}
      size={size}
      SuffixIcon={SuffixIcon}
      variant={variant}
      {...restProps}
    >
      {children}
    </Chip>
  );
};
